export default "__VITE_ASSET__WM1zD2lv__ 150w, __VITE_ASSET__Ccl_f9GI__ 300w, __VITE_ASSET__YaHfbJ4N__ 450w";